/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CostItemDto
 */
export interface CostItemDto {
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    costType?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof CostItemDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CostItemDto
     */
    monthlyCost?: number;
    /**
     * 
     * @type {Date}
     * @memberof CostItemDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CostItemDto
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CostItemDto
     */
    sunk?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof CostItemDto
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof CostItemDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CostItemDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof CostItemDto
     */
    updatedBy?: string;
}

/**
 * Check if a given object implements the CostItemDto interface.
 */
export function instanceOfCostItemDto(value: object): value is CostItemDto {
    return true;
}

export function CostItemDtoFromJSON(json: any): CostItemDto {
    return CostItemDtoFromJSONTyped(json, false);
}

export function CostItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'costType': json['costType'] == null ? undefined : json['costType'],
        'category': json['category'] == null ? undefined : json['category'],
        'status': json['status'] == null ? undefined : json['status'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'sunk': json['sunk'] == null ? undefined : json['sunk'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function CostItemDtoToJSON(json: any): CostItemDto {
    return CostItemDtoToJSONTyped(json, false);
}

export function CostItemDtoToJSONTyped(value?: CostItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'initiativeId': value['initiativeId'],
        'name': value['name'],
        'description': value['description'],
        'costType': value['costType'],
        'category': value['category'],
        'status': value['status'],
        'amount': value['amount'],
        'monthlyCost': value['monthlyCost'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'sunk': value['sunk'],
        'notes': value['notes'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
    };
}

